import styled from "styled-components";

export const SideMenuItemsContainerDefaultBox = styled.li`
   position: relative;
    display: block;
    border: none;
    margin: 1px 1.2rem 0 1.2rem;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 0 1.6rem;
    }

    &::before {
        content: "";
        display: block;
        position: absolute;
        top: -2px;
        left: 0;
        width: 100%;

        box-sizing: content-box;
        height: 1px;
        background-color: ${({theme}) => theme.colors.backgroundDark};
        box-shadow: 0px 0.35px 0px 0px ${({theme}) => theme.colors.boxBorderContrast};
        margin-bottom: 1px;
    }

    &:first-child {
        margin-top: 0;
        &::before {
            display: none;
        }
    }
`;
